export enum UserRoutes {
    UserCreate = 'create',
    UserList = '',
    UserProfile = 'profile'
}
